import Loader from "components/Loader";
import MessagePopup from "components/MessagePopup";
import VoidPopup from "components/Payment/VoidPopup";
import FilterBar from "components/Payment/FilterBar";
import ListTable from "components/Payment/ListTable";
import { useEffect, useState } from "react";
import { getPayments } from "services/payment";
import { SettlementPopup } from "components/Payment/SettlementPopup";

export default function Payment(props: any) {
  const { hotel } = props;
  const defaultPayment = {};
  const [loading, setLoading] = useState(false);
  const [fetchCount, setFetchCount] = useState(0);
  const [filter, setFilter] = useState({ notSend: false, filtering: false });
  const [Payments, setPayments] = useState<any>([]);
  /* use for editPopup component to update info */
  const [Payment, setPayment] = useState(defaultPayment);
  const [voidSingle, setVoidSingle] = useState<boolean>(true);
  const [popup, setPopup] = useState<any>({
    void: false,
    settlement: false,
  });
  const [selectedRecords, setSelectedRecords] = useState<string[]>([]);

  const [queryString, setQueryString] = useState<any>({
    confirmationNumber: undefined,
    checkInDate: undefined,
    createdAt: undefined,
  });

  /* for initial get all records */
  useEffect(() => {
    getData();
  }, [fetchCount]);

  const getData = async () => {
    const query = getQueryString();
    setLoading(true);
    const Payments = await getPayments(query);
    setPayments([...Payments]);
    setLoading(false);
  };

  const getQueryString = () => {
    const allEmpty = Object.values(queryString).every((value) => !value);
    if (allEmpty) return "";

    const queries = Object.keys(queryString)
      .filter((key) => {
        return !!queryString[key];
      })
      .map((key) => {
        return `"${key}":"${queryString[key]}"`;
      })
      .join(",");

    const conditionJson = queries ? `{${queries}}` : "";
    return `?filter=${conditionJson}`;
  };

  const searchByQueryString = async () => {
    setPayments(queryString);
    await getData();
  };

  return (
    <>
      <MessagePopup />
      <VoidPopup
        {...{
          Payment,
          setPayment,
          popup,
          setPopup,
          loading,
          setLoading,
          selectedRecords,
          setSelectedRecords,
          voidSingle,
        }}
      />
      <SettlementPopup
        {...{
          Payment,
          setPayment,
          popup,
          setPopup,
          loading,
          setLoading,
          selectedRecords,
          setSelectedRecords,
        }}
      />
      {loading || Payments === undefined ? (
        <Loader text="loading..." />
      ) : (
        <>
          <FilterBar
            {...{
              queryString,
              setQueryString,
              searchByQueryString,
              loading,
              setLoading,
              selectedRecords,
              popup,
              setPopup,
              setPayments,
              setSelectedRecords,
            }}
          />
          <ListTable
            selectedRecords={selectedRecords}
            setSelectedRecords={setSelectedRecords}
            hotel={hotel}
            Payments={Payments}
            setPayment={setPayment}
            popup={popup}
            setPopup={setPopup}
            filter={filter}
            setFilter={setFilter}
            fetchCount={fetchCount}
            setFetchCount={setFetchCount}
            queryString={queryString}
            voidSingle={voidSingle}
            setVoidSingle={setVoidSingle}
          />
        </>
      )}
    </>
  );
}
